import axios from "axios";
if (window.location.hostname == "localhost") {
  axios.defaults.baseURL = "http://localhost:8000/api/";
} else {
  const default_url = window.location.origin;
  axios.defaults.baseURL =
    localStorage.getItem("server_api") != null
      ? localStorage.getItem("server_api")
      : `${default_url}/api/`;
}
axios.defaults.headers = { "X-Requested-With": "XMLHttpRequest" };
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    switch (error.response.status) {
      case 401:
        if (localStorage.getItem("server") != null) {
          localStorage.removeItem("server_api");
          localStorage.removeItem("server");
          window.location.reload();
        }
        break;
      case 464:
        // Replace with your notification handler, e.g., using a global event bus or imported notify function
        if (
          typeof window !== "undefined" &&
          window.Vue &&
          window.Vue.prototype.$notify
        ) {
          window.Vue.prototype.$notify({
            text: "تم تجازو حدود الرخصة المسموح بها لهذا الترخيص",
            type: "error",
          });
        } else {
          alert(
            "تم تجازو حدود الرخصة المسموح بها لهذا الترخيص: " +
              error.response.data,
          );
        }
        break;
      default:
        break;
    }
  },
);
